import {getQueryParam} from "../misc/utils"
import {PARTNER_LINKS_PATH, PARTNER_LINK_VORLAGEN} from "../misc/partner-links"
import TomClient from "../services/tomClient"
import {ROOT_DIALOG_POINTER} from "../components/RootComponents/RootDialog"
import { getPointerOfWidget } from "../misc/widget-functions"

const LINKS = "/links"


export const ApplicationActions = ({getDataFromBackend, updateData, getDataFromPointer, triggerAction}) => {
    return {
        INIT_ROUTING: () => {
            const initLink = sessionStorage.getItem("initUrl")
            const href = initLink
                ? initLink
                : window._env_.BACKEND_API_URL + "/api"

            return Promise.all([
                window._env_.BACKEND_API_URL &&
                getDataFromBackend(
                    {href},
                    "/",
                ),
                window._env_.TARIFERHOEHUNG_BACKEND_API_URL &&
                getDataFromBackend(
                    {
                        href:
                            window._env_.TARIFERHOEHUNG_BACKEND_API_URL +
                            "/api",
                    },
                    "/",
                ),
                window._env_.UWPPLUS_BACKEND_API_URL &&
                getDataFromBackend(
                    {
                        href:
                            window._env_.UWPPLUS_BACKEND_API_URL +
                            "/api",
                    },
                    "/",
                ),
                TomClient.getEnrich(PARTNER_LINKS_PATH).catch((error) => {
                    console.warn(
                        "[INIT_ROUTING] Partner-Links nicht ladbar —",
                        "ist die Partner-Basis im tom-server konfiguriert?",
                        error,
                    )
                    return null
                }),
            ]).then(async ([vw, tariferhoehung, uwp, partner]) => {
                const links = [vw, tariferhoehung, uwp].reduce(
                    (prev, curr) => ({...prev, ...curr?._links}),
                    {},
                )
                updateData({...links, ...(partner?.links ?? {})}, LINKS)
                updateData(partner?.templates ?? {}, PARTNER_LINK_VORLAGEN)
                if (uwp?._links?.scenarioStart) {
                    triggerAction("INIT_STAGING_AREA", {stagingArea: uwp._links.scenarioStart})
                }
                return triggerAction("INIT_VORSORGE_ASSISTENT")
            })
        },
        DEFAULT_PAGE_INIT: () => {
            const initDataUrl = getQueryParam("initUrl")
            if (initDataUrl) {
                getDataFromBackend(
                    {
                        href: initDataUrl,
                        methods: ["GET"],
                    },
                    "/",
                ).then((payload) =>
                    getDataFromBackend(payload._links.loadPerson, "/kundeNp"),
                )
            }
        },
        CLOSE_FINO_DIALOG: () => {
            updateData("", ROOT_DIALOG_POINTER)
        },
        OPEN_DIALOG:({widget}) => {
            updateData(true, getPointerOfWidget(widget))
        },
        CLOSE_DIALOG:({widget}) => {
            updateData(false, getPointerOfWidget(widget))
        }
    }
}
